function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
  id: "gd_svg__c"
}, /*#__PURE__*/React.createElement("g", {
  id: "gd_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  id: "gd_svg__a",
  fill: "#fcd116",
  d: "M0-1v1h.5",
  transform: "rotate(18 0 -1)"
}), /*#__PURE__*/React.createElement("use", {
  transform: "scale(-1 1)",
  xlinkHref: "#gd_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  transform: "rotate(72)",
  xlinkHref: "#gd_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  transform: "rotate(144)",
  xlinkHref: "#gd_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  transform: "rotate(216)",
  xlinkHref: "#gd_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  transform: "rotate(288)",
  xlinkHref: "#gd_svg__b"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ce1126",
  d: "M0 0h640v480H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#007a5e",
  d: "M67.2 67.2h505.6v345.6H67.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcd116",
  d: "M67.2 67.3h505.6L67.2 412.9h505.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 319.9,
  cy: 240.1,
  r: 57.6,
  fill: "#ce1126"
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "matrix(52.8 0 0 52.8 320 240)",
  xlinkHref: "#gd_svg__c"
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  x: -100,
  transform: "translate(-30.3)",
  xlinkHref: "#gd_svg__d"
});

var _ref8 = /*#__PURE__*/React.createElement("use", {
  id: "gd_svg__d",
  width: "100%",
  height: "100%",
  transform: "matrix(31.2 0 0 31.2 320 33.6)",
  xlinkHref: "#gd_svg__c"
});

var _ref9 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  x: 100,
  transform: "translate(30.3)",
  xlinkHref: "#gd_svg__d"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#ce1126",
  d: "M102.3 240.7a80.4 80.4 0 0033.5 33.2 111 111 0 00-11.3-45l-22.2 11.8z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcd116",
  d: "M90.1 194.7c10.4 21.7-27.1 73.7 35.5 85.9a63.2 63.2 0 01-10.9-41.9 70 70 0 0132.5 30.8c16.4-59.5-42-55.8-57.1-74.8z"
});

var _ref12 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  x: -100,
  transform: "translate(-30.3 414.6)",
  xlinkHref: "#gd_svg__d"
});

var _ref13 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "matrix(31.2 0 0 31.2 320 448.2)",
  xlinkHref: "#gd_svg__c"
});

var _ref14 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  x: 100,
  transform: "translate(30.3 414.6)",
  xlinkHref: "#gd_svg__d"
});

var SvgGd = function SvgGd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

export default SvgGd;